export default {
    topic: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/topic/state.js